export const LOGIN_ENTITY_NAME = {
  EMAIL: 'email',
  USERNAME: 'username',
};
